import { addBreadcrumb } from '@sentry/react';
import {
  CoreApi,
  HelpLinesColliderComponent,
  PlannerEcsMultiSystem,
  TVComponent
} from '@inter-ikea-storageone/range';
import { reportMoveArticle, reportMoveTv, reportSelectEntity } from 'analytics/reporters';
import { ComponentIds, ProductUtils, Entity, SelectedComponent } from '@inter-ikea-core/core';
import { IsDraggedComponent } from '@inter-ikea-core/core';

/**
 * Sends an analytics event when something is dragged in the scene and when
 * a entity is selected in the scene
 */
export class SceneInteractionReporterSystem extends PlannerEcsMultiSystem<
  SelectedComponent | IsDraggedComponent
> {
  constructor(coreApi: CoreApi) {
    super(coreApi, 'SceneInteractionReporterSystem', [
      ComponentIds.IS_DRAGGED_COMPONENT_ID,
      ComponentIds.SELECTED_COMPONENT_ID
    ]);
  }

  onAdd(entity: Entity, newComponent: SelectedComponent | IsDraggedComponent): void {
    if (newComponent.typeId === ComponentIds.SELECTED_COMPONENT_ID) {
      const articleNbr = this.coreApi.entities.getGlobalArticleNumber(entity);
      if (articleNbr) {
        addBreadcrumb({ message: `Selecting ${ProductUtils.productRef(entity)} in scene` });
        reportSelectEntity({ articleNumber: articleNbr });
      }
    }
  }

  onUpdate(): void {}

  onRemove(entity: Entity, oldComponent: SelectedComponent | IsDraggedComponent): void {
    if (oldComponent.typeId === ComponentIds.IS_DRAGGED_COMPONENT_ID) {
      const articleNbr = this.coreApi.entities.getGlobalArticleNumber(entity);
      if (articleNbr) {
        const slantedWallOutOfBoundsCompoenent = entity.getComponent(HelpLinesColliderComponent.id);
        reportMoveArticle(
          slantedWallOutOfBoundsCompoenent
            ? {
                articleNumber: articleNbr,
                slantedWallOutOfBounds: true
              }
            : { articleNumber: articleNbr }
        );
      }
      const bestaTv = entity.hasComponent(TVComponent.id);
      if (bestaTv) {
        reportMoveTv();
      }
    }
  }
}
